import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

const testimonials = [
  {
    name: "Siddharth Rai",
    role: "CTO at musicalmeet",
    content: "Horizon Global's technical expertise and innovative approach transformed our platform. Their deep understanding of modern web frameworks helped us build a scalable solution that exceeded our expectations.",
    initials: "SR",
  },
  {
    name: "Tarun Khatta",
    role: "Founder at Clotch",
    content: "The Global Horizon team possesses deep technical knowledge and a true sense of responsibility. They worked tirelessly to bring my dream project, CLOTCH.IN, to life. From start to finish, their service was remarkable—handling everything from payment gateway to logistics integration, and even training me on the admin panel. Despite project delays caused by external issues, the team remained patient and professional, adapting to every requirement change. I highly recommend consulting with them; if you communicate your details effectively, the outcome will be seamless.",
    initials: "TK",
  },
  {
    name: "Nidhi Rai",
    role: "Founder at kiwaad",
    content: "The team at Horizon Global brought our vision to life with incredible attention to detail. Their web design and development skills created a platform that perfectly represents our mission and values.",
    initials: "NR",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-background border-t border-border/50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">Client Stories</h2>
          <p className="text-muted-foreground text-lg">
            Hear from the partners we've helped grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full bg-muted/20 border-none hover:bg-muted/40 transition-colors duration-300">
                <CardContent className="pt-8 px-8 pb-8 flex flex-col h-full">
                  <Quote className="w-8 h-8 text-primary/40 mb-6" />
                  <p className="text-lg text-foreground/90 italic mb-6 flex-grow">
                    "{testimonial.content}"
                  </p>
                  <div className="flex items-center gap-4 mt-auto">
                    <Avatar className="h-10 w-10 border border-border">
                      <AvatarFallback className="bg-primary/10 text-primary font-bold">
                        {testimonial.initials}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <p className="font-bold text-sm">{testimonial.name}</p>
                      <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
